const HomeRoute = {
  path: '',
    name: 'Home Legacy',
    component: () => import("@/views/Home.vue"),
    meta: {
    fullWidth: true,
      noSpacingBottom: true,
  }
}
export default HomeRoute;
